import { load } from './loader';

const loadReCaptcha = () =>
  load([
    // `https://www.recaptcha.net/recaptcha/api.js?render=${process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY}`,
    `https://www.google.com/recaptcha/enterprise.js?render=${process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY}`,
  ]);

export default loadReCaptcha;
